const giftBoxABI = [
  {
    "constant": false,
    "inputs": [
      {
        "name": "_uuid",
        "type": "string"
      },
      {
        "name": "_receiver",
        "type": "address"
      },
      {
        "name": "_message",
        "type": "string"
      },
      {
        "name": "_senderName",
        "type": "string"
      },
      {
        "name": "_receiverName",
        "type": "string"
      }
    ],
    "name": "sendGift",
    "outputs": [
      {
        "name": "",
        "type": "bool"
      }
    ],
    "payable": true,
    "stateMutability": "payable",
    "type": "function"
  },
  {
    "constant": false,
    "inputs": [
      {
        "name": "_uuid",
        "type": "string"
      }
    ],
    "name": "cancelGift",
    "outputs": [],
    "payable": false,
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "constant": true,
    "inputs": [
      {
        "name": "_receiver",
        "type": "address"
      }
    ],
    "name": "getGiftLength",
    "outputs": [
      {
        "name": "",
        "type": "uint256"
      }
    ],
    "payable": false,
    "stateMutability": "view",
    "type": "function"
  },
  {
    "constant": false,
    "inputs": [],
    "name": "kill",
    "outputs": [],
    "payable": false,
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "constant": true,
    "inputs": [
      {
        "name": "_uuid",
        "type": "string"
      }
    ],
    "name": "getGift",
    "outputs": [
      {
        "name": "uuid",
        "type": "string"
      },
      {
        "name": "ethPrice",
        "type": "uint256"
      },
      {
        "name": "isReceived",
        "type": "bool"
      },
      {
        "name": "sender",
        "type": "address"
      },
      {
        "name": "receiver",
        "type": "address"
      },
      {
        "name": "message",
        "type": "string"
      },
      {
        "name": "senderName",
        "type": "string"
      },
      {
        "name": "receiverName",
        "type": "string"
      },
      {
        "name": "isCancelled",
        "type": "bool"
      }
    ],
    "payable": false,
    "stateMutability": "view",
    "type": "function"
  },
  {
    "constant": true,
    "inputs": [],
    "name": "commissionPrice",
    "outputs": [
      {
        "name": "",
        "type": "uint256"
      }
    ],
    "payable": false,
    "stateMutability": "view",
    "type": "function"
  },
  {
    "constant": true,
    "inputs": [
      {
        "name": "_receiver",
        "type": "address"
      },
      {
        "name": "_index",
        "type": "uint256"
      }
    ],
    "name": "getGift",
    "outputs": [
      {
        "name": "uuid",
        "type": "string"
      },
      {
        "name": "ethPrice",
        "type": "uint256"
      },
      {
        "name": "isReceived",
        "type": "bool"
      },
      {
        "name": "sender",
        "type": "address"
      },
      {
        "name": "receiver",
        "type": "address"
      },
      {
        "name": "message",
        "type": "string"
      },
      {
        "name": "senderName",
        "type": "string"
      },
      {
        "name": "receiverName",
        "type": "string"
      },
      {
        "name": "isCancelled",
        "type": "bool"
      }
    ],
    "payable": false,
    "stateMutability": "view",
    "type": "function"
  },
  {
    "constant": true,
    "inputs": [],
    "name": "owner",
    "outputs": [
      {
        "name": "",
        "type": "address"
      }
    ],
    "payable": false,
    "stateMutability": "view",
    "type": "function"
  },
  {
    "constant": false,
    "inputs": [
      {
        "name": "_commissionPrice",
        "type": "uint256"
      }
    ],
    "name": "changeCommissionPrice",
    "outputs": [],
    "payable": false,
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "constant": false,
    "inputs": [
      {
        "name": "_uuid",
        "type": "string"
      }
    ],
    "name": "receiveGift",
    "outputs": [],
    "payable": false,
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "constant": true,
    "inputs": [
      {
        "name": "_uuid",
        "type": "string"
      }
    ],
    "name": "isGiftExist",
    "outputs": [
      {
        "name": "",
        "type": "bool"
      }
    ],
    "payable": false,
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "name": "_commissionPrice",
        "type": "uint256"
      }
    ],
    "payable": false,
    "stateMutability": "nonpayable",
    "type": "constructor"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "name": "sender",
        "type": "address"
      },
      {
        "indexed": true,
        "name": "receiver",
        "type": "address"
      },
      {
        "indexed": false,
        "name": "giftUuid",
        "type": "string"
      }
    ],
    "name": "OnGiftSend",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "name": "sender",
        "type": "address"
      },
      {
        "indexed": true,
        "name": "receiver",
        "type": "address"
      },
      {
        "indexed": false,
        "name": "giftUuid",
        "type": "string"
      }
    ],
    "name": "OnGiftReceived",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "name": "sender",
        "type": "address"
      },
      {
        "indexed": true,
        "name": "receiver",
        "type": "address"
      },
      {
        "indexed": false,
        "name": "giftUuid",
        "type": "string"
      },
      {
        "indexed": false,
        "name": "succeeded",
        "type": "bool"
      }
    ],
    "name": "OnGiftCancelled",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "name": "sender",
        "type": "address"
      },
      {
        "indexed": true,
        "name": "receiver",
        "type": "address"
      },
      {
        "indexed": false,
        "name": "giftUuid",
        "type": "string"
      }
    ],
    "name": "WasGiftCancelled",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "name": "sender",
        "type": "address"
      },
      {
        "indexed": true,
        "name": "receiver",
        "type": "address"
      },
      {
        "indexed": false,
        "name": "giftUuid",
        "type": "string"
      }
    ],
    "name": "WasGiftReceived",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "name": "giftUuid",
        "type": "string"
      }
    ],
    "name": "IsGiftAlreadyExist",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "name": "commissionPrice",
        "type": "uint256"
      }
    ],
    "name": "OnCommissionPriceChanged",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "name": "giftUuid",
        "type": "string"
      }
    ],
    "name": "OnValueUnderCommission",
    "type": "event"
  }
]

export default giftBoxABI



// WEBPACK FOOTER //
// ./src/services/GiftBoxABI.js